export enum EBatteryLevel {
    FULL = 'Full',
    LOW = 'Low',
    WARNING = 'Warning',
    NOT_CONNECTED = 'Not Connected',
}
